












import Vue from "vue";
import Error from "@/components/basic/Error.vue";
import { DELETE_ERROR } from "@/constants/mutation-types";
import { mapState } from "vuex";

export default Vue.extend({
  name: "Radio",
  props: {
    label: String,
    name: String,
    value: [String, Boolean, Number],
    checked: Boolean,
    handlesError: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hasError: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData(): void {
      if (this.formDataStore.hasOwnProperty(this.name)) {
        if (this.name !== "usaTaxPayer") {
          this.change();
        }
      }
    },
    change() {
      this.$store.commit(DELETE_ERROR, this.name);
      this.$emit("change", this.value);
    },
  },
  computed: {
    ...mapState({
      isErrorsChanged(): boolean {
        return this.$store.state.isErrorsChanged;
      },

      formDataStore(): any {
        return this.$store.state.formData;
      },
    }),
  },
  watch: {
    isErrorsChanged() {
      this.hasError = this.$store.state.errors.get(this.name);
    },
  },
  components: {
    Error,
  },
});
